var _ = require('underscore');
import f from './functions.js'

var Chats = function (core){
    var self = this

    var chats = {}
    var readpromises = {}

    var prepareChats = function(chats){
        _.each(chats, prepareChat)
        
        return chats
    }

    var prepareChat = function(chat){
        var me = core.user.info.userinfo.id

        var redactions = _.filter(chat.events, (e) => {
            return e.type == 'redaction'
        })

        _.each(chat.events, (e) => {

            if(e.creator == me) e.byme = true
            else if(e.byme) delete e.byme


            if(e.type != 'redaction' && e.type != 'read'){
                _.each(chat.read_markers, (marker) => {

                    var readKey = marker.creator == me ? 'read' : 'anotherRead'

                    if(new Date(e.date) < new Date(marker.date)){
                        e[readKey] = marker
                    }
                    else{
                        if(e[readKey]) delete e[readKey]
                    }

                })

                var eredactions = _.filter(redactions, (r) => {
                    return r.relation == e.id
                })

                _.each(eredactions, (redaction) => {
                    if(redaction.data.type == 'edit'){
                        e.data = {...redaction.data.edited}
                    }

                    if (redaction.data.type == 'remove'){
                        e.removed = true
                    }
                })
            }


        })
    }

    self.init = function(){
        core.on('synk', 'chats', ({data, id, date}) => {

            chats[id] = prepareChats(data.chats)

            core.store.commit('chat', {id, chats : chats[id]})
        })
    }

    self.destroy = function(){
        core.store.commit('chats', {})

        core.off('synk', 'chats')
    }

    self.helpers = {
        getChatForUser : function(uid, chatId){ 
            return _.find(core.store.state.chats?.[uid], (chat) => {
                return chat.uid == chatId
            })
        },

        getChatsForUser : function(uid){ 
            return core.store.state.chats?.[uid] || []
        },

        getChatIdForUserContext : function(uid, context){ 

            var account = core.appInfo?.snippity?.[context]

            if(!account) return false

            var chat = null
            
            _.find(chats?.[uid], (c) => {

                if(_.find(c.members, (m) => {
                    return m.relation == account.id
                })){
                    chat = c

                    return true
                }
               
            })

            if(!chat) return false

            return chat.uid
        },

        getunreadCountByChat : function(uid, chatId){
            var chat = self.helpers.getChatForUser(uid, chatId)

            if(!chat) return 0


            var chatEvents =  _.sortBy(_.filter(chat.events, (e) => {
                return e.type == 'message' && !e.removed
            }), (e) => {
                return - new Date(e.date)
            })

            var c = 0

            for(var i = 0; i < chatEvents.length; i++){

                var e = chatEvents[i]

                var byme = e.creator == uid

                if (byme || e.read){
                    break
                }

                c++
            }


            return c
        },

        getunreadCount : function(uid, {context = [], chatsId = []} = {}){
            if(!uid) return 0

            var ids = _.uniq(_.map(context, (c) => {
                return helpers.getChatIdForUserContext(c)
            }).concat(chatsId))

            if(!ids.length){
                ids = _.map(core.store.state.chats?.[uid] || [], (chat) => {
                    return chat.uid
                })
            }

            return _.reduce(ids, (m, id) => {
                return m + helpers.getunreadCountByChat(uid, id)
            }, 0)
        }
    }

    self.api = {
        remove : function(room, eventsId){
            if(!_.isArray(eventsId)) eventsId = [eventsId]

            return self.api.sendToRoom(room, _.map(eventsId, (id) => {
                return {
                    data : {
                        type : 'remove'
                    },
                    relation : id,
                    type : 'redaction'
                }
            }))
        },
        send : function(events){
            return core.api.chat.send(events)
        },

        sendToRoom : function(room, events){
            return self.api.send(_.map(events, (e) => {
                return {
                    ...e,
                    room
                }
            }))
        },

        sendMessagesToRoom : function(room, messages){
            if(!_.isArray(messages)) messages = [messages]

            return self.api.sendToRoom(room, _.map(messages, (m) => {
                return {
                    ...m,
                    type : 'message'
                }
            }))
        },

        read : function(rooms){

            var hash = f.md5(JSON.stringify(rooms))

            if (readpromises[hash]) return readpromises[hash]

            var events = _.map(rooms, (room) => {
                return {
                    type : 'read',
                    room,
                    data : {}
                }
            })

            var me = core.user.info.userinfo.id

            //var ntr = []

            
            events = _.filter(events, (event) => {

                //if(event.type == 'read') return false

                var chat = _.find(chats[me] || [], (chat) => {return chat.uid == event.room})

                if(!chat){
                    return null
                }

                var needToRead = _.filter(chat.events, (e) => {

                    var byme = e.creator == me

                    if(!e.read && !byme && e.type == 'message') return true
                })


                _.each(needToRead, (e) => {
                    e.read = true
                })

                if (needToRead.length){
                    return true
                }
            })

            if(!events.length){
                return Promise.resolve()
            }

            core.store.commit('chat', {me, chats : chats[me]})

            var promise = core.api.chat.send(events) //Promise.resolve() // 

            readpromises[hash] = promise

            return promise.finally(() => {
                delete readpromises[hash]
            })
        },

        getEvents : function(chat, from, count = 10){

            var added = 0

            var fromIndex = -1

            if (from){
                fromIndex = _.findIndex(chat.events, (e, i) => {
                    return e.id == from
                })
            }

            var exist = _.filter(chat.events, (e, index) => {
                if (fromIndex < index && added < count){
                    added ++ 
                    from = e.id
                    return true
                }
            })

            var loadPromise = () => {

                console.log('chat.events.length', fromIndex, chat.events.length, count)
    
                if(chat.events.length >= fromIndex + 1 + count){
                    return Promise.resolve({
                        events : [],
                        end : false
                    })
                }

                //TODO

                return core.api.chat.getEvents(chat.uid, from, count).then(d => {

                    d.newdata = true

                    return Promise.resolve(d)
                }).catch(e => {


                    ////TODO

                    return Promise.resolve({
                        events : [],
                        end : false
                    })
                })

                
            }

            return loadPromise().then(({events, end, newdata}) => {

                chat.events = chat.events.concat(events)

                chat.events = _.uniq(chat.events, (e) => {
                    return e.uid
                })

                var me = core.user.info.userinfo.id

                core.store.commit('chat', {me, chats : prepareChats(chats[me])})

                var total = exist.concat(events)

                if (newdata){
                    core.sync.saveLocal()
                }

                return Promise.resolve({
                    events : total, 
                    end
                })

            })

            
        }
    }

    return self
}


export default Chats
